import { inject } from '@angular/core';

import { UserService } from '@frontend/vanilla/core';

import { PortalNavigationService } from '../services/portal-navigation.service';

export const CommunicationGuard = () => {
    const portalNavigation = inject(PortalNavigationService);
    const user = inject(UserService);

    if (user?.claims?.get('jurisdiction')?.toUpperCase() === 'GBR') {
        portalNavigation.navigate('/commspreference');
        return false;
    }
    return true;
};
